import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { onCategorySubmit, onCategoryList } from "../../controller/CategoryController";
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Form } from 'react-bootstrap';
import { CategoryEntity } from "../../dto/category/CategoryEntity";

const Category = () => {
  const navigate = useNavigate();

  const [category, setCategory] = useState<CategoryEntity>({
    status: 'ACTIVE',
    freightRequiredFlag: true,   // default you want
    onWebTop: false,
    listingFeeAmount: 100,
    listingFeeCurrency: "MNT",
    medias: []
  });

  const [categoryList, setCategoryList] = useState<Array<CategoryEntity>>([]);
  const usedRoles = category.medias?.map(m => m.role).filter(r => r) ?? [];
  
  useEffect(() => {
    if (!AuthUtility.isUserLoggedIn()) {
        navigate("/login");
        window.location.reload();
    } else {
        categoryListGet();
    }
  }, [])

  const handleAddMedia = () => {
    if ((category.medias?.length ?? 0) >= 3) return;
  
    setCategory(prev => ({
      ...prev,
      medias: [
        ...(prev.medias ?? []),
        {
          role: nextRole(),
          status: "ACTIVE",
          data: undefined,
          preview: undefined
        }
      ]
    }));
  };

  const categorySubmit = async () => {
    try {
        const formData = new FormData();
    
        // 1️⃣ Prepare category JSON (without files!)
        const categoryPayload = {
          ...category,
          medias: category.medias?.map(m => ({
            role: m.role,
            status: m.status
          }))
        };
    
        // 2️⃣ Append category JSON
        formData.append(
          "category",
          new Blob([JSON.stringify(categoryPayload)], {
            type: "application/json"
          })
        );
    
        // 3️⃣ Append media files
        category.medias?.forEach((m) => {
          if (m.data) {
            formData.append("data", m.data);
          }
        });
    
        // 4️⃣ Send
        const response = await onCategorySubmit(formData);
        if (response.status === 0) {
            toast.success(response.msg);
        }
    
      } catch (e) {
        toast.error("Амжилтгүй");
      }
  }

  const nextRole = () => {
    const used = new Set(category.medias?.map(m => m.role));
    if (!used.has("ICON")) return "ICON";
    if (!used.has("COVER")) return "COVER";
    return "BANNER";
  };

  const categoryListGet = async () => {
    const response = await onCategoryList();
    setCategoryList(response.data.beans);
  }

  return (
    <Container fluid>
        <div><Toaster position="top-right" reverseOrder={false}/></div>
        <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Категори</h3>
        <Form>
            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="categoryName">
                        <Form.Label>НЭР</Form.Label>
                        <Form.Control
                        size="sm"
                        type="text"
                        value={category.name ?? ""}
                        onChange={(e) =>
                            setCategory({ ...category, name: e.target.value })
                        }
                        required
                        />
                        <Form.Control.Feedback type="invalid">
                            Нэр оруулна уу.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="categoryParentId">
                        <Form.Label>ҮНДСЭН КАТЕГОРИ</Form.Label>
                        <Form.Select size="sm" 
                        onChange = {(event) => {
                            setCategory({
                                ...category,
                                parentId: parseInt(event.target.value)
                            })
                        }}>
                            <option value=""></option>
                            {
                                categoryList.map((item, index) => {
                                    return <option key={index}
                                    value={item.id}>{item.fullName}</option>
                                })
                            }
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="categoryOrder">
                        <Form.Label>ЭРЭМБЭ</Form.Label>
                        <Form.Control size="sm" type="text" 
                        onChange = {(event) => {
                            setCategory({
                                ...category,
                                sortOrder: parseInt(event.target.value)
                            })
                        }} 
                        required />
                        <Form.Control.Feedback type="invalid">
                            Эрэмбэ оруулна уу.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="categoryOnWebTop">
                        <Form.Label>СТАТУС</Form.Label>
                        <Form.Select
                        size="sm"
                        value={category.status}
                        onChange={(event) => {
                            setCategory({
                                ...category,
                                status: event.target.value as any
                            })
                        }}
                        required>
                            <option value="ACTIVE">ACTIVE</option>
                            <option value="HIDDEN">HIDDEN</option>
                            <option value="DISABLED">DISABLED</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="categoryFreight">
                        <Form.Label>ХҮРГЭЛТТЭЙ</Form.Label>
                        <Form.Select
                        size="sm"
                        value={category.freightRequiredFlag ? "true" : "false"}
                        onChange={(event) => {
                            setCategory({
                                ...category,
                                freightRequiredFlag: event.target.value === "true"
                            })
                        }}
                        required>
                            <option value="true">ТИЙМ</option>
                            <option value="false">ҮГҮЙ</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="categoryOnWebTop">
                        <Form.Label>ВЕБИЙН ДЭЭР ХАРАГДАХ</Form.Label>
                        <Form.Select
                        size="sm"
                        value={category.onWebTop ? "true" : "false"}
                        onChange={(event) => {
                            setCategory({
                                ...category,
                                onWebTop: event.target.value === "true"
                            })
                        }}
                        required>
                            <option value="false">ҮГҮЙ</option>
                            <option value="true">ТИЙМ</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="categoryListingFeeAmount">
                        <Form.Label>ДУУДЛАГА ХУДАЛДАА ОРУУЛАХ ШИМТГЭЛ</Form.Label>
                        <Form.Control size="sm" type="text" value={category.listingFeeAmount}
                        onChange = {(event) => {
                            setCategory({
                                ...category,
                                listingFeeAmount: parseInt(event.target.value)
                            })
                        }} 
                        required />
                        <Form.Control.Feedback type="invalid">
                            Шимтгэл оруулна уу.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col sm={9} md={9} lg={9}>
                        
                    {category.medias?.map((m, i) => (
                    <Row key={i} className="border rounded p-2 mb-2">
                        <Col md={4}>
                            <Form.Select size="sm"
                                value={m.role}
                                onChange={(e) => {
                                    const temp = [...(category.medias ?? [])];
                                    temp[i].role = e.target.value as any;
                                    setCategory({ ...category, medias: temp });
                                }}
                                required
                            >
                                <option value="ICON" disabled={usedRoles.includes("ICON") && m.role !== "ICON"}>ICON</option>
                                <option value="COVER" disabled={usedRoles.includes("COVER") && m.role !== "COVER"}>COVER</option>
                                <option value="BANNER" disabled={usedRoles.includes("BANNER") && m.role !== "BANNER"}>BANNER</option>
                            </Form.Select>
                        </Col>

                        <Col md={4}>
                            <Form.Select size="sm"
                                value={m.status}
                                onChange={(e) => {
                                    const temp = [...(category.medias ?? [])];
                                    temp[i].status = e.target.value as any;
                                    setCategory({ ...category, medias: temp });
                                }}
                                required
                            >
                                <option value="ACTIVE">ACTIVE</option>
                                <option value="DRAFT">DRAFT</option>
                                <option value="DISABLED">DISABLED</option>
                                <option value="DELETED">DELETED</option>
                            </Form.Select>
                        </Col>

                        <Col md={3}>
                            <Form.Control
                                type="file"
                                accept="image/*"
                                size="sm"
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    const file = e.target.files?.[0];
                                    const temp = [...(category.medias ?? [])];
                                    temp[i].data = file;
                                    temp[i].preview = file ? URL.createObjectURL(file) : undefined;
                                    setCategory({ ...category, medias: temp });
                                }}
                                required
                            />
                        </Col>

                        <Col md={1} className="d-flex align-items-center">
                            <Button
                                size="sm"
                                variant="danger"
                                onClick={() => {
                                    const temp = [...(category.medias ?? [])];
                                    temp.splice(i, 1);
                                    setCategory({ ...category, medias: temp });
                                }}
                            >
                                X
                            </Button>
                        </Col>

                        {m.preview && (
                        <Col md={12} className="pt-2">
                            <img src={m.preview} height={70} />
                        </Col>
                        )}
                    </Row>
                    ))}

                    <Button
                    size="sm"
                    variant="secondary"
                    disabled={(category.medias?.length ?? 0) >= 3}
                    onClick={handleAddMedia}
                    >
                    + Зураг нэмэх
                    </Button>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm={3} md={3} lg={3}>
                    <Button size="sm" type="button" onClick={categorySubmit}>
                        Хадгалах
                    </Button>
                </Col>
            </Row>  
        </Form>
    </Container>
  )
}

export default Category;